<template>
    <div class="page-wrapper">
        <div v-if="!step">
            <section class="relative w-full h-[160px]" data-section-type="HeroBanner" data-section-variant="default" data-section-theme="black">
                <!-- Insert Image Here -->
                <div class="container mx-auto px-6 py-6 xl:py-8 xl:px-4 flex flex-col items-start justify-center absolute inset-0 z-20 text-shadow">
                    <h1>Order Photos</h1>
                </div>
            </section>
            <section class="container xl:max-w-[900px] mx-auto py-8 px-4 grid gap-2">
                <div class="flex flex-column text-center" v-if="loading">
                    <p class="text-gray-700 my-5 w-full">
                        <font-awesome-icon fixed-width icon="spinner" pulse class="mr-2"></font-awesome-icon>
                        Finding Photos...
                    </p>
                </div>

                <Access
                    v-on:nextStep="nextStep"
                    v-on:resetStudent="resetStudent"
                    :pageError="pageError"
                ></Access>
            </section>
        </div>
        <section class="container mx-auto py-8 px-4 grid gap-2 order-process" v-if="step && step.length > 0">
            <Stepper
                v-if="stepLabelsArePrepared"
                :numSteps="Object.keys(stepLabels).length"
                :stepLabels="stepLabels"
                :currentStep="step"
                v-on:goToStep="goToStep"
            ></Stepper>

            <div class="border-t-2 border-leonard-grey w-full my-4 p-6" v-if="stepLabelsArePrepared && student.name">
                <h2 class="text-leonard-green text-center mb-5">{{ student.name }}</h2>
                <Yearbook
                    v-if="checkStep('Yearbook')"
                    v-on:nextStep="nextStep"
                ></Yearbook>
                <StepOne
                    :disableBack="disableStepOneBackButton"
                    v-if="checkStep('Favorites')"
                    v-on:back="previousStep"
                    v-on:nextStep="nextStep"
                ></StepOne>
                <StepTwo
                    v-if="checkStep('Packages') && !$route.params.package"
                    v-on:nextStep="nextStep"
                    v-on:back="previousStep"
                    v-on:goToStep="goToStep"
                ></StepTwo>
                <StepThree
                    :numSteps="Object.keys(stepLabels).length"
                    v-if="checkStep('Add Ons') && !$route.params.package"
                    v-on:nextStep="nextStep"
                    v-on:back="previousStep"
                    v-on:goToStep="goToStep"
                ></StepThree>
                <PoseSelection
                    v-if="
                        (checkStep('Packages') || checkStep('Add Ons')) &&
                            $route.params.package &&
                            $route.params.package !== 'retouching'
                    "
                    v-on:back="previousStep"
                    v-on:goToStep="goToStep"
                ></PoseSelection>
                <Retouching
                    v-if="
                        checkStep('Add Ons') &&
                            $route.params.package &&
                            $route.params.package === 'retouching'
                    "
                    v-on:nextStep="nextStep"
                    v-on:back="previousStep"
                    v-on:goToStep="goToStep"
                ></Retouching>
                <Checkout
                    :numSteps="Object.keys(stepLabels).length"
                    v-if="checkStep('Checkout')"
                    v-on:nextStep="nextStep"
                    v-on:back="previousStep"
                ></Checkout>
            </div>
        </section>
    </div>
</template>

<script>
import {library} from "@fortawesome/fontawesome-svg-core";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {endOfDay, isAfter} from "date-fns";

import Order from "../classes/Order";
import Setting from "../classes/Setting";

import Access from "./ordersteps/Access";
import Stepper from "../components/partials/Stepper";
import Yearbook from "./ordersteps/Yearbook";
import StepOne from "./ordersteps/Step1";
import StepTwo from "./ordersteps/Step2";
import StepThree from "./ordersteps/Step3";
import Checkout from "./ordersteps/Checkout";
import PoseSelection from "./ordersteps/PoseSelection";
import Retouching from "./ordersteps/Retouching";

export default {
    data() {
        return {
            Order: new Order(),
            Setting: new Setting(),

            defaultStepLabels: [
                { Yearbook: { id: 1, slug: "yearbook" } },
                { Favorites: { id: 2, slug: "favorites" } },
                { Packages: { id: 3, slug: "packages" } },
                { "Add Ons": { id: 4, slug: "addons" } },
                { Checkout: { id: 5, slug: "checkout" } }
            ],
            stepLabels: [],
            stepLabelsArePrepared: false,
            step: this.$route.params.step || null,

            student: {},

            disableStepOneBackButton: false,
            hasStudioContract: false,
            yearbookCutoff: false,
            skipPackages: false,

            loading: false,
            pageError: null,
            isAfter,
            endOfDay
        };
    },

    // runs on a route change after vue is loaded
    async beforeRouteUpdate(to, from, next) {
        const accessCode = localStorage.getItem("access_code");
        const step = to.params.step || null;

        if (step && !accessCode) {
            console.warn("no access code");
            return;
        }

        if (!this.student?.name && accessCode) {
            await this.getStudentInformation();
            this.updateSteps();
        }

        if (this.student?.name) {
            next();
        }
    },

    // runs on a page hard refresh and vue loads the first time
    beforeRouteEnter(to, from, next) {
        next(async vm => {
            const accessCode = localStorage.getItem("access_code");
            const step = to.params.step || null;

            if (step && !accessCode) {
                console.warn("no access code");
                return;
            }

            if (step && accessCode) {
                vm.loading = true;

                if (!vm.student?.name) {
                    await vm.getStudentInformation();
                    vm.updateSteps();
                }
            }
        });
    },

    created() {
        library.add(faSpinner);
    },

    methods: {
        setLabels () {
            this.stepLabels = JSON.parse(JSON.stringify(this.defaultStepLabels));
        },

        reset() {
            this.setLabels();

            this.student = {};
            this.hasStudioContract = false;
            this.disableStepOneBackButton = false;
            this.stepLabelsArePrepared = false;
            this.skipPackages = false;
            this.step = this.$route.params.step || null;
            this.yearbookCutoff = false;
        },

        resetStudent() {
            this.stepLabels.length === 0 ? this.setLabels() : this.reset();
            this.student = {};
        },

        async determineStep(currentStep, data, direction = "next") {
            const lastStepIndex = this.stepLabels.length - 1;
            const currentStepPosition = this.stepLabels.findIndex(
                stepLabel => Object.values(stepLabel)[0]?.slug === currentStep
            );

            let newStep = direction === "next"
                ? (currentStepPosition < lastStepIndex ? currentStepPosition + 1 : 0)
                : (currentStepPosition > 0 ? currentStepPosition - 1 : lastStepIndex);

            newStep = this.stepLabels[newStep] ? Object.values(this.stepLabels[newStep])[0]?.slug : null;

            if (
                direction === "next"
                && (currentStep === "yearbook" || currentStep === null)
                && this.yearbookCutoff
                // && (this.hasStudioContract || this.yearbookCutoff)
            ) {
                return "favorites";
            } else if (currentStep === null) {
                return newStep;
            }

            if (direction === "next" && currentStep === "packages" && this.skipPackages) {
                return "addons";
            }

            return data?.step || newStep;
        },

        updateSteps() {
            this.stepLabels = [
                ...(this.yearbookCutoff ? [] : [{ Yearbook: { slug: "yearbook", id: 1 } }]),
                // ...(this.hasStudioContract && !this.yearbookCutoff ? [] : [{ Yearbook: { slug: "yearbook", id: 1 } }]),
                { Favorites: { slug: "favorites" } },
                ...(!this.skipPackages ? [{ Packages: { slug: "packages" } }] : []),
                { "Add Ons": { slug: "addons" } },
                { Checkout: { slug: "checkout" } }
            ].map((entry, index) => {
                const key = Object.keys(entry)[0];
                entry[key].id = index + 1;
                return entry;
            });

            this.stepLabelsArePrepared = true;
        },

        checkStep(stepLabel) {
            const filteredSteps = this.stepLabels.filter(
                step =>
                    Object.keys(step)[0] === stepLabel &&
                    Object.values(step)[0].slug === this.$route.params.step
            );

            // check if the back button should be disabled
            this.isStepOneBackDisabled();

            return filteredSteps.length === 1;
        },

        async goToStep(slug, query = null, packageData = null) {
            await this.$router.push({
                params: { step: slug, package: packageData },
                query
            });
        },

        async navigateStep(direction, data = null, query = {}) {
            if (!this.student?.name) {
                await this.getStudentInformation();
                this.updateSteps();
            }

            const step = await this.determineStep(this.step, data, direction);

            if (step) {
                await this.goToStep(step, query, data?.pkg);
            } else {
                console.error("Step could not be determined.");
            }
        },

        async nextStep(data = null, query = {}) {
            await this.navigateStep("next", data, query);
        },

        async previousStep() {
            await this.navigateStep("previous");
        },

        async getStudentInformation() {
            const access_code = localStorage.getItem("access_code");
            let yearbookCutoff = localStorage.getItem("yearbook_cutoff")?.trim();
            const data = { recpt_no: access_code.substring(0, 8) };

            try {
                const response = await this.Order.getStudent(data);
                if (!response.success) {
                    this.pageError = { title: "Error During Redirect", message: response.message };
                    window.events.$emit("finishedLoading");
                    return;
                }

                const { data: studentData } = response;
                this.student = studentData;
                // this.hasStudioContract = studentData?.hasStudioContract || false;

                // check if there is a yearbook cutoff date
                let cutoffDate;
                if (!!yearbookCutoff && (yearbookCutoff !== '' && yearbookCutoff !== 'null')) {
                    cutoffDate = new Date(yearbookCutoff);
                    this.yearbookCutoff = !isNaN(cutoffDate) && cutoffDate < new Date();
                } else {
                    this.yearbookCutoff = false;
                }

                await this.checkDate(studentData.schyear);
            } catch (error) {
                console.error("Error fetching student information:", error);
            } finally {
                this.loading = false;
            }
        },

        async checkDate(school_year) {
            try {
                const response = await this.Setting.getCutoffMonth();
                this.skipPackages = this.checkSkippable(school_year, response.data);
            } catch (error) {
                console.error("Error fetching cutoff month:", error);
            }
        },

        checkSkippable(schyear, monthCutoff) {
            const year = "20" + schyear.split("-")[1];
            const today = new Date();
            const schoolDate = new Date().setFullYear(
                parseInt(year),
                parseInt(monthCutoff) - 1,
                1
            );
            const checkDate = new Date().setFullYear(
                today.getFullYear(),
                today.getMonth(),
                1
            );

            return checkDate >= schoolDate;
        },

        isStepOneBackDisabled() {
            try {
                if (this.step === 'yearbook') {
                    this.disableStepOneBackButton = this.stepLabels.some(step => step.Yearbook && step.Yearbook.id === 1) && this.step === 'yearbook';
                    return;
                }

                this.disableStepOneBackButton = this.stepLabels.some(step => step.Favorites && step.Favorites.id === 1) && this.step === 'favorites';
            } catch (error) {
                console.error('Error checking if back is disabled:', error);
                this.disableStepOneBackButton = false;
            }
        }
    },

    watch: {
        $route(to, from) {
            this.step = to.params.step || null;
        }
    },

    components: {
        Yearbook,
        Stepper,
        Access,
        StepOne,
        StepTwo,
        StepThree,
        PoseSelection,
        Retouching,
        Checkout
    }
};
</script>
